import * as React from "react"
import { geoMercator, geoPath } from "d3-geo"
import { feature } from "topojson-client"
import { CountryData } from 'src/constants/worldMapdata';
import { Grid } from '@material-ui/core';
import { UserType } from '../../constants/Enum/UserType';


export default class WorldMapComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            worldData: [],
        }
    }
    projection() {
        return geoMercator()
            .scale(150)
    }

    componentDidMount() {
        this.setState({
            worldData: feature(CountryData, CountryData.objects.AllCountriesGeoJson).features,
        })
    }

    RenderMapPath(d: any, percentage: any, key: any) {
        let fill: string = "#ccccb3";
        let stroke: string = "#ccccb3";
        if (percentage !== null && percentage === 100) {
            fill = "#00cc00";
            stroke = "#00cc00";
        }
        else if (percentage !== null && percentage > 0 && percentage < 100) {
            // fill = "yellow";
            // stroke = "yellow";
            fill = "#FF8C00";
            stroke = "#FF8C00"; // #FF8C00
        }
        else if (percentage !== null && percentage === 0) {
            fill = "red";
            stroke = "red"; // #FF8C00
        }

        return < path
            key={`path-${key}`}
            d={geoPath().projection(this.projection())(d)}
            fill={fill}
            stroke={stroke}
            strokeWidth={0.75}
        />
    }

    RenderMap(worldMapData: any) {
        const pathArray: any = [];
        const regions: any = this.props.regionData;
        const assignCoutry = this.props.regionData.length;
        const countryList: any[] = [];
        for (let i = 0; i < assignCoutry; i++) {
            this.props.regionData[i].countryAndModuleTypeData.map((country: any, key: any) => {
                countryList.push(country)
            })
        }

        if (this.props.isAdmin !== UserType.DataCollector) {
            worldMapData.map((d: any, key: any) => {
                const isPresent = regions && regions.filter((item: any) => (item.name === d.properties.region));
                const isRegionPresent = isPresent && isPresent[0] && isPresent[0].countryAndModuleTypeData.filter((item: any) => (item.name === d.properties.name));

                pathArray.push(this.RenderMapPath(d, isRegionPresent && isRegionPresent.length > 0 ? isRegionPresent[0].totalCompletionPercentage : null, key));
            });
        }
        else {
            worldMapData.map((d: any, key: any) => {
                const isPresent = countryList && countryList.filter((item: any) => (item.name === d.properties.name));
                pathArray.push(this.RenderMapPath(d, isPresent && isPresent.length > 0 ? isPresent[0].totalCompletionPercentage : null, key));
            });
        }
        return pathArray;
    }
    render() {
        return (
            <Grid item={true} xs={8} lg={6} xl={6}>
                <svg width={600} height={500} viewBox="0 0 950 350">
                    <g className="countries">
                        {
                            this.RenderMap(this.state.worldData)
                        }
                    </g>
                </svg>
                <div className="legendDiv">
                    <ul className="listsquare">
                        <li className="color-red">
                            <span> No data submitted</span>
                        </li>
                        <li className="color-orange">
                            <span> Data submission in progress</span>
                        </li>
                        <li className="color-green">
                            <span> Data submission completed</span>
                        </li>
                    </ul>
                </div>
            </Grid>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/dashboard/WorldMapComponent.tsx